export enum BbvmsEnum {
    Paused = 'paused',
    Playing = 'playing',
    Idle = 'idle',
    Loading = 'loading',
}
